import mapData from "./v102UiToProtocolMap.json";
import { V102_FN_BLOCKED_POSITIONS } from "./dakaiModels";

export type V102UiProtocolCell = {
  uiRow: number;
  uiCol: number;
  code: number;
  sn: number;
  idx: number;
};

const cells = mapData as V102UiProtocolCell[];

const byUi = new Map<string, V102UiProtocolCell>();
for (const c of cells) {
  byUi.set(`${c.uiRow}:${c.uiCol}`, c);
}

export function resolveV102ProtocolCell(
  uiRow: number,
  uiCol: number
): V102UiProtocolCell | undefined {
  return byUi.get(`${uiRow}:${uiCol}`);
}

export function isV102FnBlockedPosition(pos: number): boolean {
  return V102_FN_BLOCKED_POSITIONS.some((p) => p === (pos & 0xff));
}
